<template>
  <div class="tradelaw-view">
    <!-- ページヘッダー -->
    <section class="page-hero">
      <div class="container">
        <h1 class="page-hero__title">特定商取引法に基づく表記</h1>
        <p class="page-hero__subtitle">Trade Law</p>
      </div>
    </section>

    <!-- 特定商取引法セクション -->
    <base-section>
      <div class="tradelaw-content">
        <div class="tradelaw-table-wrapper">
          <table class="tradelaw-table">
            <tbody>
              <tr>
                <th>事業者名</th>
                <td>レンタルスペースkaonR</td>
              </tr>
              <tr>
                <th>代表者</th>
                <td>水谷理子</td>
              </tr>
              <tr>
                <th>事業者所在地</th>
                <td>東京都港区南青山2-2-15</td>
              </tr>
              <tr>
                <th>問い合わせ</th>
                <td>
                  03-6804-1059<br>
                  サービスについてのお問い合わせは、メールにて受け付けております。<br>
                  ご不便をお掛けいたしますが、<router-link to="/contact">こちら</router-link>からお問い合わせください。
                </td>
              </tr>
              <tr>
                <th>メールアドレス</th>
                <td>
                  <strong>■ご予約・見学</strong><br>
                  reserve&#64;kaon-r.jp<br><br>
                  <strong>■お問い合わせ（上記以外）</strong><br>
                  contact&#64;kaon-r.jp
                </td>
              </tr>
              <tr>
                <th>サービス利用価格</th>
                <td>ご予約・見学受付のページ内に表示する価格になります。</td>
              </tr>
              <tr>
                <th>代金の支払い方法・時期</th>
                <td>
                  <strong>■クレジットカード</strong><br>
                  ご予約時に代金を決済していただきます。<br><br>
                  <strong>■コンビニ決済／ペイジー（銀行ATM・インターネットバンキング決済）</strong><br>
                  レンタルスペースのご予約日の翌日から起算して3日以内（以下「コンビニ決済等のお支払い期限」といいます）にお支払いいただきます。<br>
                  コンビニ決済等のお支払い期限までにお支払いを確認できていない場合には、原則としてご予約を自動でキャンセルさせていただきます。<br><br>
                  お支払いの際に生じる手数料は、スペース利用者様にご負担いただきます。
                </td>
              </tr>
              <tr>
                <th>サービス利用料金以外の費用</th>
                <td>
                  お支払い手数料。<br>
                  レンタルスペース利用料金のお支払い手数料は、スペース利用者様負担となっております。
                </td>
              </tr>
              <tr>
                <th>提供時期</th>
                <td>レンタルスペースご利用日当日が役務の提供時期となります。</td>
              </tr>
              <tr>
                <th>キャンセル</th>
                <td>
                  キャンセルポリシーにて既定のキャンセル料金をいただきます。<br>
                  レンタルスペースのご予約前に、事前にご確認ください。
                </td>
              </tr>
              <tr>
                <th>推奨環境・対応端末</th>
                <td>PC端末または、モバイル／タブレット端末にてご利用可能です。</td>
              </tr>
              <tr>
                <th>不良品の取り扱い条件</th>
                <td>商品の性質上、返品は承っておりません。</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </base-section>
  </div>
</template>

<script>
import BaseSection from '@/components/common/BaseSection.vue';

export default {
  name: 'TradelawView',
  components: {
    BaseSection
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';

.tradelaw-view {
  padding-top: 0;
}

// ページヘッダー
.page-hero {
  background: linear-gradient(135deg, $primary-color 0%, $primary-light 100%);
  color: $white;
  padding: $spacing-4xl 0;
  text-align: center;
  
  @include media-breakpoint-down(md) {
    padding: $spacing-3xl 0;
  }
  
  &__title {
    font-size: $font-size-4xl;
    font-weight: 700;
    margin-bottom: $spacing-md;
    color: $white;
    
    @include media-breakpoint-down(md) {
      font-size: $font-size-3xl;
    }
  }
  
  &__subtitle {
    font-size: $font-size-xl;
    opacity: 0.9;
    
    @include media-breakpoint-down(md) {
      font-size: $font-size-lg;
    }
  }
}

// コンテンツ
.tradelaw-content {
  max-width: 960px;
  margin: 0 auto;
}

.tradelaw-table-wrapper {
  background: $white;
  border-radius: $radius-lg;
  overflow: hidden;
  box-shadow: $shadow-sm;
}

.tradelaw-table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  
  th {
    width: 25%;
    background-color: $primary-light;
    color: $white;
    padding: $spacing-lg;
    text-align: left;
    font-weight: 600;
    font-size: $font-size-md;
    border-bottom: 1px solid rgba($white, 0.2);
    
    @include media-breakpoint-down(md) {
      width: 100%;
      display: block;
      text-align: center;
    }
  }
  
  td {
    padding: $spacing-lg;
    background-color: $white;
    font-size: $font-size-md;
    line-height: 1.8;
    color: $gray-700;
    border-bottom: 1px solid $gray-200;
    
    @include media-breakpoint-down(md) {
      display: block;
      width: 100%;
      padding: $spacing-md $spacing-lg;
    }
    
    a {
      color: $primary-color;
      text-decoration: none;
      font-weight: 500;
      transition: color $transition-base;
      
      &:hover {
        color: $primary-dark;
        text-decoration: underline;
      }
    }
    
    strong {
      color: $gray-800;
      font-weight: 600;
    }
  }
  
  tr:last-child {
    th, td {
      border-bottom: none;
    }
  }
  
  @include media-breakpoint-down(md) {
    tr {
      display: block;
      margin-bottom: $spacing-xs;
      
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>